export const generativeAiStandardsRunHistory = "/:app_group_id/generative_ai/standards_run_history";
